import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  Box,
  IconButton,
  Tooltip,
  Checkbox,
  Button,
  Card,
  Collapse
} from '@mui/material'; // Añadir Collapse
import {
  Receipt as ReceiptIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material'; // Añadir ExpandMoreIcon y ExpandLessIcon
import TableRowsIcon from '@mui/icons-material/TableRows';
const TablaDetallada = ({ pedidos, onSeleccionarFacturacion }) => {
  const [expanded, setExpanded] = useState(false); 
  const [selected, setSelected] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'fecha_orden', direction: 'desc' });

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = pedidos
        // .filter(p => p.factura_consfinal !== 1)
        .map(p => p.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelect = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter(item => item !== id);
    }

    setSelected(newSelected);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedPedidos = [...pedidos].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const formatFecha = (fechaString) => {
    if (!fechaString) return 'N/A';
    return new Date(fechaString).toLocaleDateString('es-AR');
  };

  const SortableHeader = ({ label, sortKey }) => (
    <Box display="flex" alignItems="center">
      {label}
      <IconButton size="small" onClick={() => handleSort(sortKey)}>
        {sortConfig.key === sortKey ? (
          sortConfig.direction === 'asc' ? 
            <ArrowUpwardIcon fontSize="small" /> : 
            <ArrowDownwardIcon fontSize="small" />
        ) : (
          <ArrowUpwardIcon fontSize="small" sx={{ opacity: 0.3 }} />
        )}
      </IconButton>
    </Box>
  );

  return (
    <Card sx={{ mt: 2 }}>
      <Box p={2}>
        {/* Header plegable */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <TableRowsIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" fontWeight="bold">
              Detalle de Entregas
            </Typography>
          </Box>
          
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body2" color="text.secondary">
              Seleccionados: <strong>{selected.length}</strong>
            </Typography>
            {selected.length > 0 && (
              <Button
                variant="contained"
                startIcon={<ReceiptIcon />}
                onClick={() => onSeleccionarFacturacion(selected)}
                size="small"
              >
                Facturar seleccionados
              </Button>
            )}
            <IconButton 
              size="small"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Box>
        </Box>

        <Collapse in={expanded}>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selected.length > 0 && selected.length < pedidos.length}
                      checked={selected.length === pedidos.length && pedidos.length > 0}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    <SortableHeader label="ID" sortKey="id" />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    <SortableHeader label="Fecha" sortKey="fecha_orden" />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Cliente</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Producto</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Remito</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Estado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedPedidos.map((pedido) => (
                  <TableRow 
                    key={pedido.id}
                    hover
                    sx={{ 
                      opacity: 1,
                      backgroundColor: 'inherit'
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(pedido.id)}
                        onChange={() => handleSelect(pedido.id)}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold">
                        #{pedido.id}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatFecha(pedido.fecha_orden)}
                      </Typography>
                      {/* <Typography variant="caption" color="text.secondary">
                        {pedido.fecha_format}
                      </Typography> */}
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Typography variant="body2">{pedido.cliente}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {pedido.sucursal_cliente}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {pedido.producto}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {pedido.remito_entrega ? (
                        <Chip 
                          label={pedido.remito_entrega}
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      ) : (
                        <Typography variant="caption" color="text.secondary">
                          Sin remito
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={0.5}>
                        {pedido.valor === 'Entregado Con Remito' ? (
                          <CheckCircleIcon fontSize="small" color="success" />
                        ) : (
                          <WarningIcon fontSize="small" color="warning" />
                        )}
                        <Typography variant="body2">
                          {pedido.valor}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </Box>
    </Card>
  );
};

export default TablaDetallada;